import React from "react";
import {
  Box,
  Grid,
  Image,
  Center,
  Button,
  Heading,
  Link,
  Text,
  Container,
  SimpleGrid,
} from "@chakra-ui/react";
import { ActiveLinkProvider } from "./ActiveLinkContext";
import Header from "../components/Header";
import Footer from "../components/Footer";
import lash1 from "../images/lashes1.png";
import lash2 from "../images/lashes2.png";
import lash3 from "../images/lashes3.png";
import lash4 from "../images/lashes4.png";
import lash5 from "../images/lash5.png";
import nail1 from "../images/nails1.png";
import nail2 from "../images/nails2.png";
import nail3 from "../images/nails3.png";
import nail4 from "../images/nails4.png";
import nail5 from "../images/nails5.png";
import nail6 from "../images/nails6.png";
import nail7 from "../images/nails7.png";
import pedi from "../images/toes1.png";
import nail from "../images/tech.jpg";

function About() {
  const lashUrls = [lash1, lash2, lash3, lash4, lash5];
  const nailUrls = [nail1, nail2, nail3, nail4, nail5, nail6, nail7, pedi];

  return (
    <ActiveLinkProvider>
      <Header />
      <Box
        height={"60vh"}
        position="relative"
        backgroundPosition="center"
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
        backgroundImage={nail}
      ></Box>
      <Box
        as="section"
        id="about"
        py={16}
        bg={
          "linear-gradient(179.4deg, rgb(253, 240, 233) 2.2%, rgb(255, 194, 203) 96.2%)"
        }
      >
        <Container maxW="container.lg">
          <Heading
            textAlign="center"
            mb={8}
            fontWeight={"600"}
            color={"#f56ee8"}
            fontFamily={"Playwrite DE SAS"}
          >
            ABOUT US
          </Heading>
          <Text textAlign="left" fontSize="lg" fontWeight={"300"} mb={"0"}>
            Welcome to Annie's Beauty and Spa at 11400 4th St., Suite 102 Rancho
            Cucamonga, CA 91730. Feel free to call (909) 697-0951 to book now!{" "}
            <br /> <br />
            With over 20+ years of experience, at Annie's Beauty & Spa, we
            believe that beauty is not just a service but an experience. Our
            passionate team of skilled professionals is dedicated to providing
            you with exceptional nail care and pampering. <br /> <br />
            We strive to create a welcoming atmosphere where you can relax and
            indulge in high-quality treatments tailored to your needs. From
            elegant manicures to luxurious spa services, we are here to enhance
            your natural beauty and ensure you leave feeling rejuvenated and
            confident.
          </Text>
        </Container>
      </Box>

      {/* Photo Grid */}
      <Box
        padding={8}
        display={"flex"}
        justifyContent={"center"}
        bg={
          "linear-gradient(179.4deg, rgb(253, 240, 233) 2.2%, rgb(255, 194, 203) 96.2%)"
        }
      >
        {/* Lashes */}
        <Grid
          templateColumns={{ base: "repeat(2, 1fr)", md: "repeat(3, 1fr)" }}
          gap={5}
        >
          {lashUrls.map((url, index) => (
            <Image
              key={index}
              src={url}
              alt={`Lashes Image ${index + 1}`}
              width={"100%"}
              height="auto"
              objectFit="cover"
              borderRadius="md"
            />
          ))}
        </Grid>
      </Box>

      <Box
        padding={8}
        display={"flex"}
        justifyContent={"center"}
        bg={
          "linear-gradient(179.4deg, rgb(253, 240, 233) 2.2%, rgb(255, 194, 203) 96.2%)"
        }
      >
        {/* Nails + Toes */}
        <Grid
          templateColumns={{ base: "repeat(2, 1fr)", md: "repeat(3, 1fr)" }}
          gap={5}
        >
          {nailUrls.map((url, index) => (
            <Image
              key={index}
              src={url}
              alt={`Nails Image ${index + 1}`}
              width={"100%"}
              height="auto"
              objectFit="cover"
              borderRadius="md"
              aspectRatio={{ base: "1 / 1", md: "4 / 3" }}
            />
          ))}
        </Grid>
      </Box>

      {/* Footer + Directions */}
      <Box bg="pink" py={10} textAlign="center" paddingBottom={"100px"}>
        <hr />
        <Center>
          <Text
            padding={"20px"}
            fontSize={"lg"}
            mt={"10px"}
            fontFamily={"Dosis"}
            fontWeight={"600"}
            wordBreak={"break-word"}
            width={"50%"}
            mb={"20px"}
          >
            WE ARE BY APPOINTMENT ONLY. <br /> <br /> Please note that all
            appointment bookings and cancellations must be made at least 24
            hours in advance. If you are unable to attend, kindly notify us as
            soon as possible. Cancellations made less than 24 hours prior to
            your appointment will incur a $25 fee. The team at Annie's Nails and
            Lashes sincerely appreciate your cooperation.
          </Text>
        </Center>
        <hr />
        <Button
          mt={"40px"}
          as="a"
          href="#"
          rounded="full"
          size="lg"
          px={10}
          py={6}
          mb={"20px"}
          bg="pink.300"
          color="white"
          _hover={{ bg: "pink.500" }}
          onClick={() => {
            window.location.href =
              "https://www.google.com/maps/place/11400+Fourth+St+%23102,+Rancho+Cucamonga,+CA+91730/@34.0776817,-117.5582929,17z/data=!3m1!4b1!4m5!3m4!1s0x80c33583fed41d21:0x67ceb81e5efa4002!8m2!3d34.0776817!4d-117.555718?entry=ttu&g_ep=EgoyMDI0MDkxOC4xIKXMDSoASAFQAw%3D%3D";
          }}
        >
          Get Directions
        </Button>
        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={10} mt={10}>
          <Box>
            <Heading size="md" color="pink.300">
              Visit Us
            </Heading>
            <Text color="gray.600">
              11400 4th St., Suite 102
              <br />
              Rancho Cucamonga, CA 91730
            </Text>
          </Box>
          <Box>
            <Heading size="md" color="pink.300">
              Call Us
            </Heading>
            <Text color="gray.600">Phone: (909) 697-0951</Text>
          </Box>
          <Box>
            <Heading size="md" color="pink.300">
              Follow Us
            </Heading>
            <Link
              href="https://www.instagram.com/annienguyenlashes/?igsh=MzRlODBiNWFlZA%3D%3D"
              color="gray.600"
            >
              Instagram: @annienguyenlashes
            </Link>
          </Box>
        </SimpleGrid>
      </Box>

      <Footer />
    </ActiveLinkProvider>
  );
}

export default About;
